import {Message} from './message.model';
import {MessageLink} from './message-link.model';

export class ErrorMessage extends Message {
    constructor(title: string, content?: string, path?: string, date?: string, link?: MessageLink, persistent: boolean = false) {
        super('error', '#Error', title, content, path, date, link, persistent);
    }
}
